import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PresenceInfo } from '@app/shared/services/pusher/pusher.service';

@Component({
  selector: 'app-typing-indicator',
  templateUrl: './typing-indicator.component.html',
  styleUrls: ['./typing-indicator.component.scss']
})
export class TypingIndicatorComponent implements OnChanges {
  @Input() users: PresenceInfo[] = [];

  displayText: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users']) {
      this.updateDisplayText();
    }
  }

  private updateDisplayText(): void {
    if (!this.users || this.users.length === 0) {
      this.displayText = '';
      return;
    }

    if (this.users.length === 1) {
      this.displayText = `${this.users[0].first_name} is typing`;
    } else if (this.users.length === 2) {
      this.displayText = `${this.users[0].first_name} and ${this.users[1].first_name} are typing`;
    } else if (this.users.length === 3) {
      this.displayText = `${this.users[0].first_name}, ${this.users[1].first_name}, and ${this.users[2].first_name} are typing`;
    } else {
      this.displayText = `${this.users.length} people are typing`;
    }
  }
}
